/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.publicALaCarteProducts.internal

import features.publicALaCarteProducts.models.PublicALaCarteProductsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class PublicAlaCarteProductsServiceImpl : PublicAlaCarteProductsService {

    private val publicAlaCarteProductsRequest = PublicAlaCarteProductsRequest()

    override suspend fun getPublicAlaCarteProducts(
        overrideHeaders : Map<String, String>?,
    ): Result<PublicALaCarteProductsModel> {
        return publicAlaCarteProductsRequest.getPublicAlaCarteProducts(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
